import { REACT_QUERY_KEYS } from '@/constants'

export const usersQueryKeys = {
  all: [REACT_QUERY_KEYS.USERS] as const,
  me: () => [...usersQueryKeys.all, 'me'] as const
}
